import { createContext } from "react";

import { LicenseLeasesContextType } from "./LicenseLeasesContext.types";

export const LicenseLeasesContext = createContext<LicenseLeasesContextType | undefined>(undefined);
